type ContentMetrics = { reach?: number | null; views?: number | null };

export type ContentPeriod = "threeMonths" | "previousMonth" | "currentMonth";
const publicationDateFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: "America/Toronto", year: "numeric", month: "2-digit", day: "2-digit"
});

export function contentPeriodRange(period: ContentPeriod, now = new Date()) {
  const today = publicationDateFormatter.format(now);
  const [year, month] = today.split("-").map(Number);
  const monthStart = (offset: number) => new Date(Date.UTC(year, month - 1 + offset, 1)).toISOString().slice(0, 10);
  return { start: monthStart(period === "threeMonths" ? -2 : period === "previousMonth" ? -1 : 0),
    end: period === "previousMonth" ? new Date(Date.UTC(year, month - 1, 0)).toISOString().slice(0, 10) : today };
}

export function contentInPeriod(publishedAt: string | undefined, range: { start: string; end: string }) {
  if (!publishedAt || !Number.isFinite(Date.parse(publishedAt))) return false;
  const date = publicationDateFormatter.format(new Date(publishedAt));
  return date >= range.start && date <= range.end;
}

// Percent formatting applies x 100; keep the stored engagement rate unchanged.
export function contentAudienceViewRate({ reach, views }: ContentMetrics): number | null {
  if (reach == null || views == null || !Number.isFinite(reach) || !Number.isFinite(views) || reach < 0 || views <= 0) return null;
  return reach / views;
}

export function compareContentAudience(left: ContentMetrics, right: ContentMetrics): number {
  const sortable = (value: number | null | undefined) => value != null && Number.isFinite(value) && value >= 0 ? value : -1;
  return sortable(right.reach) - sortable(left.reach) || sortable(right.views) - sortable(left.views);
}
